import { render } from "./ContributeText.vue?vue&type=template&id=0dcecb3e"
import script from "./ContributeText.vue?vue&type=script&lang=js"
export * from "./ContributeText.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/marvel-lcg-randomizer/marvel-lcg-randomizer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__